import React from 'react'
import './CustomNumericInputField.css'
import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs'

type CustomNumericInputFieldProps = {
  id: string
  placeholder: string
  value: string | number
  onChange: (value: string) => void
  className?: string
  destructive?: boolean
  disabled?: boolean
  onBlur?: () => void
  onFocus?: () => void
  /** Hint for browser autofill; use distinct values per field so only that field is filled (e.g. "section-mobile tel", "section-home tel") */
  autocomplete?: string
}

const CustomNumericInputField: React.FC<CustomNumericInputFieldProps> = ({
  id,
  placeholder,
  value,
  onChange,
  className,
  disabled = false,
  onBlur,
  onFocus,
  autocomplete,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (disabled) return
    const inputValue = e.target.value.replace(/\D/g, '')
    if (inputValue.length <= 10) {
      onChange(inputValue)
    }
  }

  return (
    <MaskedTextBoxComponent
      cssClass={`custom-numeric-input${className ? ` ${className}` : ''}`}
      id={id}
      placeholder={placeholder}
      value={value.toString()}
      onChange={handleChange}
      mask="(000) 000-0000"
      floatLabelType="Never"
      onBlur={onBlur}
      onFocus={onFocus}
      enabled={!disabled}
      htmlAttributes={autocomplete ? { autocomplete, name: id } : { name: id }}
    ></MaskedTextBoxComponent>
  )
}

export default CustomNumericInputField
